import CadastroEvento from './CadastroEvento'

export default CadastroEvento